import { parseApiDate } from '@propertypal/shared/src/services/dayjs';
import { OpenViewing } from '@propertypal/shared/src/types';
import React from 'react';
import { useTheme } from 'styled-components';
import CalendarIcon from '../calendar/CalendarIcon';
import { Box, DefaultProps } from '../layout';
import { Text } from '../typography';
import Container from './OpenViewingOverlay.style';

interface OpenViewingOverlayProps {
  openViewing: OpenViewing;
  slider?: boolean;
}

const OpenViewingOverlay: React.FC<OpenViewingOverlayProps> = ({ openViewing, slider }) => {
  const theme = useTheme();

  const dateText = () => {
    if (openViewing.cancelled) return '';
    const date = parseApiDate(openViewing.startTime);
    if (date.isToday()) return 'Today';
    if (date.isTomorrow()) return 'Tomorrow';
    return openViewing.dayText;
  };

  const containerProps: DefaultProps & { color?: string } = {
    p: 10,
    bgColour: 'rgba(0,0,0,0.3)',
    color: theme.white,
    position: 'absolute',
    zIndex: 3,
    display: 'flex',
    bottom: slider ? '5px' : '0',
    left: slider ? '50%' : '0',
    right: slider ? 'auto' : '0',
  };

  if (slider) {
    containerProps.w = 'auto';
    containerProps.transform = 'translateX(-50%)';
  }

  return (
    <Box {...containerProps} data-testid="open-viewing-overlay">
      <Box display="flex" flexDirection="row" alignItems="center">
        <Container position="relative" flexBasis="48px" mr={10} display="flex" cancelled={openViewing.cancelled}>
          <CalendarIcon mode="white" date={openViewing.startTime} />
        </Container>
        <Box>
          <Text color={theme.white} fontWeight="bold" fontSize={14} data-testid="date-text">
            Open Viewing {dateText()}
          </Text>
          <Text
            color={openViewing.cancelled ? theme.primary : theme.white}
            fontSize={14}
            fontWeight={openViewing.cancelled ? 'bold' : 'normal'}
            data-testid="date-time"
          >
            {openViewing.cancelled ? `CANCELLED` : `Open from ${openViewing.timeText}`}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default OpenViewingOverlay;
